export enum ZoomComponentButtonPosition {
  Default = 'Default',
  Start = 'Start',
  End = 'End',
}
